// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CustomLoader_wrap__2K3bj"};